import Papa from 'papaparse'
import dayjs from 'dayjs';

// Function to export data as a file
const exportCSV = (data, fileName, type) => {
    // Create a link and download the file
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };


export default function exportData(biestList,email){
   
    let exportList = [[
        'koe nummer', 
        'koe leeftijd',
        'koe datum droogstand',
        'biest tijdstip',
        'biest volume [l]',
        'biest Brixwaarde [%]',
        'biest IgGwaarde [g/l]',
        'kalf nummer',
        'kalf beheer',
        'kalf geboortedatum',
        'bloed Brixwaarde',
        'bloed IgGwaarde',
        'biest gedronken',
        'biest type',
        'opmerkingsveld',
    ]]
    biestList.filter((biest) => biest.boerEmail === email)
    .map((userBiest) => exportList.push([
        userBiest.moederId,
        userBiest.moederLeeftijd,
        dayjs(userBiest.moederDroogstand).format('YYYY-MM-DD'),
        userBiest.biestTijdstip,
        userBiest.biestVolume,
        userBiest.biestBrixWaarde,
        userBiest.biestIgGWaarde,
        userBiest.kalfId,
        userBiest.kalfBeheer,
        dayjs(userBiest.kalfDatum).format('YYYY-MM-DD'),
        userBiest.bloedBrixWaarde,
        userBiest.bloedIgGWaarde,
        userBiest.biestGedronken,
        userBiest.biestType,
        userBiest.toelichting,
    ]))
    const csvData = Papa.unparse(exportList);
    exportCSV(csvData, 'data.csv', 'text/csv;charset=utf-8;');
}


